import { render } from "./inputPrice.vue?vue&type=template&id=7db36902&scoped=true"
import script from "./inputPrice.vue?vue&type=script&lang=js"
export * from "./inputPrice.vue?vue&type=script&lang=js"

import "./inputPrice.vue?vue&type=style&index=0&id=7db36902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db36902"]])

export default __exports__